/* This view shows the chosen book club. The view shows book club name, main genre, no. of members.
It has different sub-views/tabs like overview, members, meetings, suggestions, and settings that 
the user can toggle between. It is conditionally rendered so only the admin can see the settings tab. */

import { BookOpen, Calendar, UsersIcon, Lightbulb, Settings, ArrowLeft } from "lucide-react";
import { useState } from "react";
import HeaderView from "./headerView";
import { OverviewTabView } from "./bookClubTabs/overviewTabView";
import { SuggestionsTab } from "./bookClubTabs/SuggestionsTab.jsx";
import { useParams, useNavigate } from "react-router-dom";
import { MembersTabView } from "./bookClubTabs/membersTabView.jsx";



export function BookClubWrapperView(props){

   //  const { clubId } = useParams(); // faktiska clubId från URL:en
    const currentClub = props.currentClub;

    // Guard against null/undefined on initial render maybe add loader here instead?
    if (!currentClub || !props.currentUser) {
        return null;
    }
    console.log("get active club id", props.activeClubId);
    console.log("get current club",props.currentClub);
    console.log("get admin id", props.currentClub.adminId);
    console.log("get voting deadline", props.suggestions.votingDeadline);

    const navigate = useNavigate();

    const isAdmin = currentClub.adminId === props.currentUser.userId;
    const [activeTab, setActiveTab] = useState('overview');
    const [searchParams, setSearchParams] = useState("");

    const tabs = [
        { id: 'overview', label: 'Overview', icon: BookOpen },
        { id: 'suggestions', label: 'Suggestions', icon: Lightbulb },
        { id: 'members', label: 'Members', icon: UsersIcon },
    ];

    function renderTabsCB(tab){
        const Icon = tab.icon;

        return (
            <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-1 px-4 py-2 !rounded-lg transition-colors ${
                      activeTab === tab.id
                        ? 'bg-blue-100 text-blue-900'
                        : 'text-blue-700 hover:bg-blue-50'
                }`}
            >
                <Icon className="w-4 h-4" />
                <span>{tab.label}</span>
            </button>
        )
    }

    function goBackACB(){
        props.onBackToMyClubs()
        navigate('/myClubs');

    }
    function setSearchParamsACB(params) {
        setSearchParams(params);
    }
    function doSearchACB() {
        props.doSearch(searchParams);
    }
    function cancelPopUpACB() {
        props.cancelPopUp();
    }
    function searchBookACB(bookId) {
        props.searchBook({ bookID: bookId });
    }
    function addSuggestionACB(book) {
        props.addSuggestion(book);
    }
    function voteACB(bookId, userId, score) {
        props.vote(bookId, userId, score);
    }
    function chooseBookACB(book) {
        props.onChoosenBook(book);
    }

    return <div className="min-h-screen bg-sky-50">
        {/*<HeaderView 
            onLogout={props.onLogout} 
            currentPage='club-details'
            currentUser={props.currentUser}
        />*/}

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <button
                onClick={goBackACB}
                className="flex items-center gap-2 text-blue-700 hover:text-blue-900 mb-6 transition-colors"
            >
                <ArrowLeft className="w-4 h-4" />
                <span>Back to My Clubs</span>
            </button>
            <div className="bg-white rounded-2xl shadow-xl border border-blue-100 overflow-hidden">
                <div className="p-6 border-b border-blue-100 bg-gradient-to-r from-sky-50 to-cyan-50">
                    <div className="flex items-start justify-between">
                        <div>
                            <h1 className="text-blue-900 mb-1">{currentClub.name}</h1>
                            <p className="text-blue-700">{currentClub.genre} • {currentClub.members.length} {currentClub.members.length === 1 ? "member" : "members"}</p>
                        </div>
                        <div className="flex gap-2">
                            {isAdmin && (
                                <div className="px-4 py-2 bg-blue-500 text-white rounded-full">
                                    Admin
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Tabs */}
                <div className="border-b border-blue-100">
                    <div className="flex gap-1 p-2 overflow-x-auto">
                        {tabs.map(renderTabsCB)}
                    </div>
                </div>

                {/* Tab content */}                
                <div className="p-6">
                    {activeTab === 'overview' && (
                        <OverviewTabView
                            currentUser={props.currentUser}
                            currentBook={currentClub.currentBook}
                            deadline={currentClub.deadline}
                            members={currentClub.members}
                            noteBoard={props.noteBoard}
                            onSetPage = {props.setProgress}
                            clubId = {props.activeClubId}
                            onAddNote = {props.onAddNote}
                            onRemoveNote = {props.onRemoveNote}
                        />
                    )}
                    {/* fyll på med tabs eftersom att vi skapar dem */}
                    {activeTab === 'suggestions' && (
                        <SuggestionsTab doSearch={doSearchACB}
                                        setSearchParams={setSearchParamsACB}
                                        searchParams={searchParams}
                                        searchResults={props.searchResults}
                                        status={props.status}
                                        error={props.error}
                                        statusId={props.statusId}
                                        errorId={props.errorId}
                                        searchResultId={props.searchResultId}
                                        cancelPopUp={cancelPopUpACB}
                                        searchBook={searchBookACB}
                                        currentClub={currentClub}
                                        currentUser={props.currentUser}
                                        suggestions={props.suggestions}
                                        addSuggestion={addSuggestionACB}
                                        vote={voteACB}
                                        isAdmin={isAdmin}
                                        onChoosenBook={chooseBookACB}
                                        onStartVotingPeriod={(date) => props.onStartVotingPeriod(date)}
                                        onEndVotingPeriod={() => props.onEndVotingPeriod()}
                                        onSetDeadline={props.onSetDeadline}
                                        />
                    )}
                    {activeTab === 'members' && (
                        <MembersTabView
                            currentUser={props.currentUser}
                            currentBook={currentClub.currentBook}
                            deadline={currentClub.deadline}
                            members={currentClub.members}
                            currentClub={currentClub}
                            clubId = {props.activeClubId}
                            onAcceptRequest = {props.onAcceptRequest}
                            onRejectRequest = {props.onRejectRequest}
                        />
                    )}
                    
                </div>
            </div>
        </div>
    </div>
}